import { render, staticRenderFns } from "./AccountFlowDetail.vue?vue&type=template&id=01ab45d4&scoped=true"
import script from "./AccountFlowDetail.vue?vue&type=script&lang=js"
export * from "./AccountFlowDetail.vue?vue&type=script&lang=js"
import style0 from "./AccountFlowDetail.vue?vue&type=style&index=0&id=01ab45d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ab45d4",
  null
  
)

export default component.exports